<template>
  <v-data-table class="elevation-1" :headers="headers" :items="items" :loading="loading" :items-per-page="20"
                :options.sync="params.options" :server-items-length="params.total"
                @click:row="open($event)" :footer-props="{showFirstLastPage: true, showCurrentPage: true, itemsPerPageOptions: [20, 50, 100]}">
    <!--<template v-slot:item.pictureUrl="{ item }">
      <img :src="item.pictureUrl" width="100" height="100"/>
    </template>
    <template v-slot:item.sales="{ item }">
      <label>{{ item.sales }}</label>
      <label v-if="item.newSales > 0" style="color: red"> (+{{ item.newSales }})</label>
    </template>
    <template v-slot:item.reviews="{ item }">
      <label>{{ item.reviews }}</label>
      <label v-if="item.newReviews > 0" style="color: red"> (+{{ item.newReviews }})</label>
    </template>
    <template v-slot:item.price="{ item }">
      <label>{{ item.price }}</label>
      <label  v-if="item.price !== item.originalPrice" style="text-decoration: line-through; color: gray"> {{ item.originalPrice }}</label>
    </template>-->
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>商品列表</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field class="search" append-icon="mdi-magnify" label="搜索"
                      single-line hide-details clearable v-model="params.filters.search" @click:append="getData" @click:clear="clear" @keydown.enter="getData"></v-text-field>

        <v-dialog persistent v-model="filterDialog" @keydown.esc="closeFilterDialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-on="on" v-bind="attrs">
              <v-icon>mdi-filter-menu</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">筛选</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                          v-model="params.filters.marketplaces"
                          :items="marketplaces"
                          item-text="name"
                          item-value="code"
                          :menu-props="{ maxHeight: '400' }"
                          label="平台"
                          multiple
                          @change="initStore"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                          v-model="params.filters.stores"
                          :items="stores"
                          :menu-props="{ maxHeight: '400' }"
                          label="店铺"
                          multiple
                          @change="initAsin(); initSku()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                          v-model="params.filters.asins"
                          :items="asins"
                          :menu-props="{ maxHeight: '400' }"
                          label="ASIN"
                          multiple
                          @change="initSku"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                          v-model="params.filters.skus"
                          :items="skus"
                          :menu-props="{ maxHeight: '400' }"
                          label="SKU"
                          multiple
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="validate">保存</v-btn>
              <v-btn color="blue darken-1" text @click="closeFilterDialog">取消</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-divider></v-divider>
    </template>
    <template v-slot:item.imageUrl="{ item }">
      <img alt="商品主图" :src="item.imageUrl" height="80" width="80"/>
    </template>
    <template v-slot:item.asin="{ item }">
      <v-btn link text :href="item.store.marketplaceUrl + '/dp/' + item.asin" target="_blank" color="primary">{{ item.asin }}</v-btn>
    </template>
    <template v-slot:item.salesRanks="{ item }">
      <label v-for="(salesRank, i) of item.salesRanks" :key="i">
        {{salesRank.productCategory ? salesRank.productCategory : salesRank.productCategoryId}}: {{salesRank.curRank}}
        <br/>
      </label>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "Products",
  data() {
    return {
      loading: true,
      headers: [
        {text: "图片", align: "center", value: "imageUrl"},
        {text: "ASIN", align: "center", value: "asin"},
        {text: "SKU", align: "center", value: "sku"},
        {text: "单价", align: "center", value: "price"},
        {text: "排名", align: " center", value: "salesRanks"}/*,
        { text: "昨日销量", align: "center", value: "yesterday.sales" },
        { text: "昨日净销售额", align: "center", value: "yesterday.itemPrice" },
        { text: "昨日单价", align: "center", value: "yesterday.unitPrice" }*//*,
        { text: "上周同日销量", align: "center", value: "lastWeek.sales" },
        { text: "上周同日净销售额", align: "center", value: "lastWeek.itemPrice" },
        { text: "上周同日单价", align: "center", value: "lastWeek.unitPrice" }*/
      ],
      items: [],
      params: {
        options: {},
        filters: {
          search: null,
          marketplaces: [],
          stores: [],
          asins: [],
          skus: []
        }
      },
      total: null,
      filterDialog: false,
      marketplaces: [],
      stores: [],
      asins: [],
      skus: []
    }
  },
  mounted() {
    this.initFilter();
  },
  methods: {
    getData() {
      this.loading = true;
      this.items = [];
      this.$axios.post("/products", this.params/*{
        page: this.options.page,
        pageSize: this.options.itemsPerPage,
        orderBy: this.options.sortBy,//.length > 0 ? this.options.sortBy[0] : null,
        desc: this.options.sortDesc,//.length > 0 ? this.options.sortDesc[0] : null,
        filters: this.filters
      }*/).then(
          response => {
            if (response.data && response.data.list && response.data.list.length > 0) {
              this.items = response.data.list;
              this.params.total = response.data.total;

              for (let item of this.items) {
                this.$axios.get(this.$format("/products/{}/salesRank", item.id)).then(
                    response => {
                      this.$set(item, "salesRanks", response.data);
                    }
                );
              }
            }

            this.loading = false;
          }
      );
    },
    initFilter() {
      this.$axios.get("/stores/marketplace").then(
          response => {
            this.marketplaces = response.data;
          }
      );
      this.initStore();
      this.initAsin();
      this.initSku();
    },
    initStore() {
      this.$axios.get("/stores/name", {
        params: {
          marketplaces: this.params.filters.marketplaces
        },
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.stores = response.data;
            this.params.filters.stores = [];
            this.params.filters.asins = [];
            this.params.filters.skus = [];
          }
      );
    },
    initAsin() {
      this.$axios.get("/products/asin", {
        params: {
          stores: this.params.filters.stores
        },
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.asins = response.data;
            this.params.filters.asins = [];
            this.params.filters.skus = [];
          }
      );
    },
    initSku() {
      this.$axios.get("/products/sku", {
        params: {
          stores: this.params.filters.stores,
          asins: this.params.filters.asins
        },
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.skus = response.data;
            this.params.filters.skus = [];
          }
      );
    },
    validate() {
      this.getData();
      this.filterDialog = false;
    },
    clear() {
      setTimeout(function(){this.getData();}.bind(this), 300);
    },
    open(product) {
      console.log(product);
      this.$router.push(this.$format("/home/products/{0}", product.id));
    }, closeFilterDialog() {
      this.$refs.form.reset();
      this.filterDialog = false;
    }
  }, watch: {
    "params.options": {
      deep: true,
      handler() {
        console.log("这次的options是: " + JSON.stringify(this.params.options));
        this.getData();
      }
    }
  }
}
</script>

<style scoped>
</style>